import React, { Component } from 'react';
import { Background } from '../COMPONENTS/Background';
import { connect } from 'react-redux';
import '../styles.css';
import { OPTIONS_KEY, NORMAL, TWISTED } from '../const';
import { SIZE_PAGE } from '../../HOME/const';
import { goToPage } from '../../HOME/REDUX/actions';
import { setMode, setOptions } from '../REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import Logo from '../ASSETS/MemoryTwistLogo.png';
import { windowSize, dbget } from '../../HOME/utils';
import { getAppInfo } from '../../HOME/info';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import ModeIcon from '../COMPONENTS/ModeIcon';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

class StartPage extends Component {
  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    dbget(OPTIONS_KEY, options => {
      this.props.setOptions(options);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleMode = mode => {
    this.props.setMode(mode);
    this.props.goToPage(SIZE_PAGE);
  };

  render() {
    const { x, y } = windowSize();
    const width = Math.min(x, y) / 7;
    const appName = getAppInfo(this.props.app).name;
    const color = 'rgb(216, 153, 164)';

    return (
      <div className="page-root">
        <div className="mt-logo-title">
          <img src={Logo} width={width} alt="Memory Twist logo" />
          <span className="mt-title" style={{ color: 'black', transform: 'translate(0.05em, 0.05em)' }}>
            {appName}
          </span>
          <span className="mt-title" style={{ color, zIndex: 1, opacity: 0.75 }}>
            {appName}
          </span>
        </div>
        <div className="mt-page" style={{ backgroundImage: Background }}>
          {_.map([NORMAL, TWISTED], mode => {
            const classes = `${mode === TWISTED ? 'mt-twist-clockwise' : ''}`;
            return (
              <div
                key={mode}
                onClick={() => this.handleMode(mode)}
                className="app-option option"
                style={{ margin: '-5px', paddingLeft: '20px', textShadow: '0.08em 0.08em black' }}>
                <div style={{ display: 'grid' }}>
                  <span style={{ gridArea: '1/1', transform: 'translate(0.08em, 0.08em)' }}>
                    <div className={classes}>
                      <ModeIcon width="60" color="black" />
                    </div>
                  </span>
                  <span className={classes} style={{ gridArea: '1/1', zIndex: 1 }}>
                    <ModeIcon width="60" />
                  </span>
                </div>
                <span style={{ color, fontSize: '22px', margin: '15px', fontWeight: 'bold' }}>{mode}</span>
              </div>
            );
          })}
        </div>
        <BmgButton />
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ mt, common }) {
  return { ...mt, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, setMode, setOptions }
)(StartPage);
